import React, { PureComponent } from 'react'
import { object } from 'prop-types'
import { translate } from 'react-i18next'
import { range, sortBy } from 'lodash'
import { minutes } from 'utils/string'
import { toOrdinal } from 'number-to-words'
import { StickyTable, Row, Cell } from 'react-sticky-table'

import './Race.css'

@translate()
export class RaceTabFastLaps extends PureComponent {
    static propTypes = {
        data: object.isRequired
    }

    componentWillMount() {
        const { data } = this.props
        this.laps = range(1, data.numberOfSegments + 1)
        this.players = sortBy(data.players, 'position')
    }

    renderLapsHeader = lap => {
        const text = `Lap ${lap}`
        return (
            <Cell key={lap}>
                <div className="ST-Header-Lap">{text}</div>
            </Cell>
        )
    }
    renderPlayerRow = ({ id, position, color, player, segments }) => (
        <Row key={id}>
            <Cell>
                <div className="ST-Header-Player">
                    <div className="PlayerColor" style={{ backgroundColor: color }} />
                    {player}<small> ({toOrdinal(position)})</small>
                </div>
            </Cell>
            {segments.map(this.renderSegmentCell)}
        </Row>
    )
    renderSegmentCell = ({ time, pitstop, rankingForThisSegment }, index) => (
        <Cell key={index}>
            <div className={['Time', { WithPitstop: pitstop }]} style={{ backgroundColor: rankingToColor(rankingForThisSegment) }}>{minutes(time)}</div>
        </Cell>
    )

    render() {
        const { t } = this.props
        return (
            <div className="RaceTabFastLaps h-100">
                <div className="RaceTabFastLaps-Legend flex row-right-center">
                    <div className="RaceTabFastLaps-Legend-Item Pitstop">
                        {t('game.RACE.legend.pitstop')}
                    </div>
                </div>
                <StickyTable>
                    <Row>
                        <Cell />
                        {this.laps.map(this.renderLapsHeader)}
                    </Row>
                    {this.players.map(this.renderPlayerRow)}
                </StickyTable>
            </div>
        )
    }
}

// ranking is a value from 0 to 1 that represent how the player has done (in time) in the current lap respect the fastest and slowest one
const colorForFastest = [60, 200, 60]
const colorForSlowest = [208, 2, 27]
function rankingToColor(ranking) {
    const [r, g, b] = rankingToRGB(ranking)
    return `rgba(${r},${g},${b},0.3)`
}
function rankingToRGB(ranking) {
    return [
        Math.round(colorInterpolate(ranking, colorForFastest[0], colorForSlowest[0])),
        Math.round(colorInterpolate(ranking, colorForFastest[1], colorForSlowest[1])),
        Math.round(colorInterpolate(ranking, colorForFastest[2], colorForSlowest[2]))
    ]
}
function colorInterpolate(v, c1, c2) {
    return c2 + (v * (c1 - c2))
}



// WEBPACK FOOTER //
// src/pages/Phases/Race/RaceTabFastLaps.js